'use strict';

var DropEffects = {
  COPY: 'copy',
  MOVE: 'move',
  LINK: 'link'
};

module.exports = DropEffects;


/*****************
 ** WEBPACK FOOTER
 ** ../modules/constants/DropEffects.js
 ** module id = 33
 ** module chunks = 0
 **/